<template>
	<div class="left-nav">
		<el-menu
			:default-active="routerName || $route.name"
			class="el-menu-left">
			<el-menu-item :index="item.name" :key="index"
						  :class="{'is-active2': $route.name===item.name ||  routerName ===item.name }"
						  v-for="(item,index) in menuArr">

				<a href="javascript:void(0)"
				   @click="$router.replace({path:`${item.parent}/${item.path}`,query:{t:Date.now()}})">
					<icon :name="item.icon"></icon>
					<!--<sapn v-if="item.path!='notices'">{{item.meta.title}}</sapn>-->
					<el-badge v-if="item.path=='notices'&&noticesWarn" is-dot>{{item.meta.title}}</el-badge>
					<a v-else>{{item.meta.title}}</a>
				</a>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	import {leftNavRouter} from '@/router'

	export default {
		name: 'leftnav',
		data() {
			return {
				menuArr: leftNavRouter,
			}
		},
		computed: {
			routerName() {
				return this.$route.meta.activeNav
			},
			noticesWarn() {
				let authorInfo = this.$store.getters['user/getUserInfo'] || {}
				if (authorInfo.authorMark && authorInfo.authorMark.user_unread_msg_num_data > 0) {
					return true
				} else {
					return false
				}
			},
		},
		methods: {},
		created() {
		}
	}
</script>

<style scoped lang="scss">
	.left-nav {
		position: fixed;
		background-color: #fff;
		width: 160px;
		top: 70px;
		padding: 20px 20px 0 20px;
		z-index: 100;
		box-shadow: 0 0 1px rgba(0, 0, 0, .1);
		span {
			color: #fff;
		}
		.el-menu-left {
			border: 0;
			.el-menu-item {
				color: #333;
				height: auto;
				line-height: initial;
				/*border-bottom: 1px solid #ddd;*/
				padding: 0px !important;
				margin-bottom: 42px;
				text-align: center;
				cursor: inherit;
				&:after {
					content: '';
					width: 100%;
					height: 1px;
					background: #ddd;
					float: left;
					margin-top: 18px;
				}
				&:hover {
					background-color: #fff;
				}
				a {
					color: #333;
					vertical-align: initial;
					svg {
						color: #333;
					}

				}
				&:hover {
					a {
						color: #21ade5 !important;
						svg {
							color: #21ade5 !important;
						}
					}
				}

				&.is-active2 {
					a {
						color: #21ade5 !important;
						svg {
							color: #21ade5 !important;
						}
					}
				}

			}
			& > .el-menu-item:last-child {
				margin-bottom: 21px;
				&:after {
					content: '';
					width: 0;
				}
			}
		}
	}

	.fa-icon {
		width: 20px;
		height: 17px;
		margin-right: 5px;
		vertical-align: -4px;
	}

	.el-badge {
		.el-badge__content {
			right: 1px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/leftnav.vue